module.exports = __webpack_public_path__ + "img/malecon-de-puerto-vallarta.6f55fbf6.jpg";